import { useCallback } from 'react';
import {
  ErrorIntlKey,
  SuccessIntlKey,
  triggerCopyTextToClipboard,
  useCopyTextToClipboardHandler,
  useImageToClipboardHandler,
} from 'utils/clipboard/clipboard';

export function useCopyTextToClipboard(successMessage?: SuccessIntlKey, errorMessage?: ErrorIntlKey) {
  const handler = useCopyTextToClipboardHandler(successMessage, errorMessage);
  return useCallback(
    (text: string | undefined) => {
      triggerCopyTextToClipboard(handler, text);
    },
    [handler],
  );
}

export function useCopyImageToClipboard(successMessage?: SuccessIntlKey, errorMessage?: ErrorIntlKey) {
  const handler = useImageToClipboardHandler(successMessage, errorMessage);
  return useCallback(
    (img: Blob | null) => {
      if (!handler.validate() || !handler.validateClipboardItem() || !img) {
        return;
      }
      navigator.clipboard
        .write([
          new window.ClipboardItem({
            'image/png': img,
          }),
        ])
        .then(handler.onSuccess)
        .catch(handler.onError);
    },
    [handler],
  );
}
